<%= form_with(model: score, class: "contents") do |form| %>
  <% if score.errors.any? %>
    <div id="error_explanation" class="bg-red-50 text-red-500 px-3 py-2 font-medium rounded-md mt-3">
      <h2><%= pluralize(score.errors.count, "error") %> prohibited this score from being saved:</h2>

      <ul class="list-disc ml-6">
        <% score.errors.each do |error| %>
          <li><%= error.full_message %></li>
        <% end %>
      </ul>
    </div>
  <% end %>

  <div class="my-5">
    <%= form.label :judge_id %>
    <%= form.text_field :judge_id, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": score.errors[:judge_id].none?, "border-red-400 focus:outline-red-600": score.errors[:judge_id].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :heat_id %>
    <%= form.text_field :heat_id, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": score.errors[:heat_id].none?, "border-red-400 focus:outline-red-600": score.errors[:heat_id].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :person_id %>
    <%= form.text_field :person_id, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": score.errors[:person_id].none?, "border-red-400 focus:outline-red-600": score.errors[:person_id].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :value %>
    <%= form.text_field :value, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": score.errors[:value].none?, "border-red-400 focus:outline-red-600": score.errors[:value].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :good %>
    <%= form.text_field :good, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": score.errors[:good].none?, "border-red-400 focus:outline-red-600": score.errors[:good].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :bad %>
    <%= form.text_field :bad, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": score.errors[:bad].none?, "border-red-400 focus:outline-red-600": score.errors[:bad].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :comments %>
    <%= form.text_field :comments, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": score.errors[:comments].none?, "border-red-400 focus:outline-red-600": score.errors[:comments].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :slot %>
    <%= form.number_field :slot, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": score.errors[:slot].none?, "border-red-400 focus:outline-red-600": score.errors[:slot].any?}] %>
  </div>

  <div class="inline">
    <%= form.submit class: "w-full sm:w-auto rounded-md px-3.5 py-2.5 bg-blue-600 hover:bg-blue-500 text-white inline-block font-medium cursor-pointer" %>
  </div>
<% end %>
